import { render, staticRenderFns } from "./EditMaterialToggle.vue?vue&type=template&id=4508d58f&scoped=true"
import script from "./EditMaterialToggle.vue?vue&type=script&lang=js"
export * from "./EditMaterialToggle.vue?vue&type=script&lang=js"
import style0 from "./EditMaterialToggle.vue?vue&type=style&index=0&id=4508d58f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4508d58f",
  null
  
)

export default component.exports